angular.module('dentalLinks')
.controller('NotesController', ['$scope', '$q', 'Auth', '$uibModal', 'Logger', 'ModalHandler', 'Note', 'Notification', 'Activity', 'FeatureConfig',
    function ($scope, $q, Auth, $uibModal, Logger, ModalHandler, Note, Notification, Activity, FeatureConfig) {
        $scope.auth = Auth.get();
        
        // Only fetch feature config if user is authenticated to avoid 401 errors for guest users
        if ($scope.auth && $scope.auth.id) {
            FeatureConfig.findByName({name: 'notes.generate.enabled'}).$promise
                .then(function (response) {
                    $scope.allowGenerateNotes = (response.value == 'true');
                });
        } else {
            // Default to false for unauthenticated users (guest referrals)
            $scope.allowGenerateNotes = false;
        }

        // TODO: what does this do? And in what case?
        if($scope.referral.$promise) {
            $scope.referral.$promise.then(function() {
                if (!$scope.referral.patient_id) {
                    return; // partial live draft (DCL-369): no patient linked yet
                }
                Activity.patientsChanges({patient_id: $scope.referral.patient_id, start_date: $scope.referral.created_at},
                    function(data) {
                        $scope.referral.notes = $scope.referral.notes.concat(data.activities);
                    }, function(response) {
                        // DCL-647: without this the patient-change entries just went missing.
                        // Only server errors: a user who may not read activities gets a denial
                        // the auth interceptor already handles.
                        if (response && response.status >= 500) {
                            Notification.error('Patient change history could not be loaded.');
                        }
                    });
            });
        }

        // `busy`: a draft autosave request is in flight (DCL-636). A note added
        // or edited now could race the server list that request answers with.
        $scope.noteDialog = function () {
            if ($scope.busy) { return; }
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/note_form.html',
                controller: 'NoteModalController',
                resolve: {
                    referral: function() {
                        const referral = $scope.referral;
                        return referral;
                    },
                    allowGenerate: function() {
                        // note_drafts needs a persisted referral; live drafts (DCL-369) qualify
                        // as soon as the lazy create has happened (referral.id present)
                        return !!(($scope.immediateUpdate || ($scope.referral && $scope.referral.id)) && $scope.allowGenerateNotes);
                    }
                }
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.then(function (message) {
                if ($scope.showOfferToInviteGuest) {
                    $scope.showOfferToInviteGuest();
                }
                if ($scope.immediateUpdate) {
                    Note.save({note: {message: message, referral_id: $scope.referral.id, user_id: $scope.auth.id}}, function (success) {
                        $scope.referral.notes.push(success);
                    }, function (failure) {
                        Notification.error('Something went wrong, note was not saved.');
                    });
                } else {
                    if(typeof $scope.$parent.form !== 'undefined' && $scope.$parent.form !== null) {
                        $scope.$parent.form.$setDirty(); // for UnsavedChanges to notice notes being changed
                    }
                    // Both timestamps are for showing the unsaved note (the list sorts
                    // and dates by updated_at, the PDF prints created_at), as ISO
                    // strings like a saved note's. Neither is sent: the autosave
                    // payload carries only id/message/user_id (DCL-634).
                    var now = new Date().toISOString();
                    var note = {
                        message: message,
                        created_at: now,
                        updated_at: now,
                        user_id: $scope.auth ? $scope.auth.id : '',
                        user: {
                            first_name: Auth.current_user ? Auth.current_user.first_name : '',
                            last_name: Auth.current_user ? Auth.current_user.last_name : ''
                        }
                    };
                    $scope.referral.notes = $scope.referral.notes || [];
                    $scope.referral.notes_attributes = $scope.referral.notes_attributes || [];
                    $scope.referral.notes.push(note);
                    $scope.referral.notes_attributes.push(note);
                }
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        $scope.showHistory = function(note){
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/note_versions.html',
                controller: 'NoteVersionsModalController',
                size: 'lg',
                resolve: {
                    versions : function(){
                        return note.versions;
                    }
                }
            });
        };
        
        $scope.hasUpdates = function (note) {
            return note.versions && note.versions.some(function (version) {
                return version.event === 'update'
            });
        };

        $scope.editNote = function(note, index){
            if ($scope.busy) { return; }
            // The list renders `orderBy: 'updated_at'`, so `index` is a position
            // in the sorted list; replace the note itself wherever it sits. A
            // draft edit looks the note up again on save (applyDraftEdit).
            var position = $scope.referral.notes.indexOf(note);
            if (position === -1) { position = index; }
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/edit_note_form.html',
                controller: 'EditNoteModalController',
                resolve: {
                    noteData : function(){
                        return note;
                    }
                }
            });
            modalInstance.result.then(function (edited) {
                if($scope.showOfferToInviteGuest) {
                    $scope.showOfferToInviteGuest();
                }
                if($scope.immediateUpdate){
                    Note.update({id: edited.id}, {note: edited}, function(success){
                        $scope.referral.notes[position] = success;
                    }, function(failure){
                        Notification.error('Something went wrong, note was not updated.');
                    });
                } else {
                    if(typeof $scope.$parent.form !== 'undefined' && $scope.$parent.form !== null) {
                        $scope.$parent.form.$setDirty();
                    }
                    // An autosave can start or finish while the dialog is open
                    // (DCL-636): wait for any request still in flight, then apply
                    // the edit to the list and queue as they are by then.
                    return whenIdle().then(function () { applyDraftEdit(note, edited); });
                }
            }).catch(function () {
                // Logger.log('Modal dismissed');
            });
        };

        // Resolves once no draft autosave request is in flight.
        function whenIdle() {
            if (!$scope.busy) { return $q.resolve(); }
            return $q(function (resolve) {
                var stop = $scope.$watch('busy', function (busy) {
                    if (!busy) { stop(); resolve(); }
                });
            });
        }

        // The modal returns an angular.copy, so the note is found by the
        // original object, or by id. Autosave (DCL-369) drains notes_attributes
        // after each save and replaces the list with the server's notes
        // (DCL-636). If that happened while the dialog was open, the original
        // is in neither any more, but syncSavedNotes gave it its server id: the
        // edit takes that id, so nested attributes update the saved note rather
        // than insert a second one. Otherwise a still-pending note is replaced
        // in place, or the edited copy is queued.
        function applyDraftEdit(original, edited) {
            if (!edited.id && original.id) { edited.id = original.id; }
            var referral = $scope.referral;
            referral.notes = referral.notes || [];
            referral.notes_attributes = referral.notes_attributes || [];
            replaceOrAppend(referral.notes, original, edited);
            replaceOrAppend(referral.notes_attributes, original, edited);
        }

        function replaceOrAppend(list, original, edited) {
            var index = list.indexOf(original);
            for (var i = 0; index === -1 && edited.id && i < list.length; i++) {
                // activity rows (trackable_id) share the list, not the id space
                if (list[i].id === edited.id && !list[i].trackable_id) { index = i; }
            }
            if (index === -1) { list.push(edited); } else { list[index] = edited; }
        }
    }]);
